// extracted by mini-css-extract-plugin
export default {"thumbnail":"Thumbnail_thumbnail__lBO-3","tiny":"Thumbnail_tiny__Kucj4","small":"Thumbnail_small__c1w3o","large":"Thumbnail_large__z-5EN"};